import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import { DeutschePrivatePort } from '@dbk/ui-icons';
import Text,{H4,H5} from '@dbk/ui-text';
import { ROUTES } from '../../../../constants';
import BlurModal from '../../../../components/common/blur-modal';
import { NotificationWarning } from '@dbk/ui-icons';
import envConfig from '../../../../../db-env-build';
import DbText from '../../../../assets/svgs/db-text.js';
class LandingPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = ({
      isContinueEnabled: false
    });
    this.props.docupload.lastLoginDetails();

  }

  componentDidUpdate(prevProps) {
    if (prevProps.docupload.initializeSuccess !== this.props.docupload.initializeSuccess) {
      if (this.state.navigateTodocUpload) {
        this.props.changePage(ROUTES.RMACCESS.DOC_TAB_CONTAINER);
        this.props.docupload.setInitializeSuccess(false);
      }
    }
  }

  componentDidMount() {
    const { docupload: { setDocUploadWizardIndex } } = this.props;
    setDocUploadWizardIndex(0);
  }

  onDocUploadCardClick(card) {
    this.setState({ isContinueEnabled: true })
    const docUploadCard = document.getElementById("docUploadCard");
    const bankerAccessCard = document.getElementById("bankerAccessCard");

    if (card === "docUploadCard") {
      docUploadCard.classList.add("active");
      bankerAccessCard.classList.remove('active');
      this.setState({ navigateTodocUpload: true })
    } else {
      this.setState({ navigateTodocUpload: false })
      bankerAccessCard.classList.add("active");
      docUploadCard.classList.remove('active')
    }
  }

  // onBankerAccessCardClick = () => {
  //   this.setState({ isContinueEnabled: true })
  //   const bankerAccessCard = document.getElementById("bankerAccessCard");
  //   const docUploadCard = document.getElementById("docUploadCard");
  //   bankerAccessCard.classList.add("active");
  //   docUploadCard.classList.remove('active')
  // }

  onContinueClicked = async() => {
    //this.setState({ isContinueEnabled: false })
    let isRMUpdate= true;
    let moduleName = "";
    const { docupload: { uploadInitialize, winUserId, showErrorModal }, auth: { setUserId},  rmAccess : { adminEmailId, ipAddress } } = this.props;
    if(this.state.navigateTodocUpload){
      // this is first call for userId so want to send isRMUpdate and moduleName new parameter  for 
      //CH region because need to segregate the RM read only and doc upload user
      /* start */
      if(envConfig.rmRegion === "rmch"){
        isRMUpdate = false;
        moduleName = "RM_DOC_UPLOAD";
      }
      if(!showErrorModal){
        await this.props.rmAccess.fetchUserIdDetails(adminEmailId, ipAddress, isRMUpdate, moduleName);
      }
      await uploadInitialize();
      /*End*/ 
    }else{
      if(winUserId){
        setUserId(winUserId);
      }
      /* start */
      if(envConfig.rmRegion === "rmch"){
        isRMUpdate = false;
        moduleName = "RM_READ_ONLY";
      }
      this.props.rmAccess.fetchUserIdDetails(adminEmailId, ipAddress, isRMUpdate, moduleName);
      /*End*/
      this.props.changePage("/rm-access/search");
    }
    
  }

  closeBlurModel = () => {
    this.props.docupload.setBlurModalError(false);
  }

  renderErrorModal = () => {
    const { docupload: { showErrorModal, errorTitle, errorMsg } } = this.props;

    return (
      <BlurModal
        visible={showErrorModal}
        doneVisible={false}
        title={<h4>{errorTitle}</h4>}
        onDone={() => this.closeBlurModel()}
      >
        <div className="error-message-container">
          <NotificationWarning color='#b92635' className="error-icon" width={25} height={25} />
          <span className="error-message-content">{errorMsg}</span>
        </div>
      </BlurModal>
    )
  }

  onLogoutClicked = () => {
    //  Here we call the RM logout and not DWO logout 
    this.props.rmLogout();
  }

  render() {
    const {
      i18n: { messages }, docupload: {
        lastSession,
        userName,
        showErrorModal,
        loading
      } } = this.props;
    return (
      <div className="rm-access-landing-page rm-welcome_background">
        <div className='margin-10'>
          <DbText tabIndex={-1} className={'logo-web'} />
        </div>
        <div className="card-Container">
          <div className="card-wrapper">
            <div>
              <H4 className="card-wrapper-text">{messages['app.docUpload.landingPage.welcome']}</H4>
            </div>
            <div>
              <Text className="card-wrapper-small-text"> {messages['app.rmAccess.landingPage.cardWrapper'] + " " + lastSession}</Text></div>
            <div className="card-wrapper-top-line" />
            <div className="card-wrapper-elements">
              <div className="card-body" testID="card_docUploadLanding_bankerAccess_test" accessibilityLabel="card_docUploadLanding_bankerAccess_test" onClick={() => this.onDocUploadCardClick("bankerAccessCard")}>
                <div className="card-text" id="bankerAccessCard">
                  <div className="card-items">
                    <DeutschePrivatePort width={70} height={70} color='#FFFFFF' />
                    <H5 className="card-Title">{messages['app.rmAccess.landingPage.bankerCardTitle']}</H5>
                  </div>

                  <div>
                    <Text size="large" className="card-title-elements">{messages['app.rmAccess.landingPage.cardTitleBankerElements']}</Text>
                  </div>

                </div>
              </div>
              <div className="card-body" testID="card_docUploadLanding_docUpload_test" accessibilityLabel="card_docUploadLanding_docUpload_test" onClick={() => this.onDocUploadCardClick("docUploadCard")}>
                <div className="card-text" id="docUploadCard">
                  <div className="card-items">
                    <DeutschePrivatePort width={85} height={70} color='#FFFFFF' />
                    <H5 className="card-Title"> {messages['app.rmAccess.landingPage.documentCardTitle']}</H5>
                  </div>
                  <div>
                    <Text size="large" className="card-title-elements"> {messages['app.rmAccess.landingPage.cardTitleDocumentElements']}</Text>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="landing-page-button">
            <div className="landing-page-logout-button">
              <Button
                tertiary
                size="large"
                testID="btn_docUploadLanding_logout_test"
                loading = {this.props.rmAccess.showLogoutSpinner}
                accessibilityLabel="btn_docUploadLanding_logout_test"
                onClick={this.onLogoutClicked}>
                {messages['app.rmAccess.landingPage.logoutButton']}
              </Button>

            </div>
            <div className="landing-page-continue-button">
              <Button
                disabled={!this.state.isContinueEnabled}
                size='large'
                loading={loading}
                onClick={this.onContinueClicked}
                testID="btn_docUploadLanding_continue_test"
                accessibilityLabel="btn_docUploadLanding_continue_test">
                {messages['app.rmAccess.landingPage.continueButton']}
              </Button>
            </div>
          </div>
          {showErrorModal && this.renderErrorModal()}
        </div>
      </div>
    );
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    rmLogout: { $call : 'rmAccess.logout'},
    rmAccess:{
      showLogoutSpinner : true,
      adminEmailId: true,
      ipAddress: true,
      fetchUserIdDetails: { $call: 'fetchUserIdDetails' },
    },
    docupload: {
      lastSession: true,
      userName: true,
      lastLoginDetails: { $call: 'lastLoginDetails' },
      onLogout: { $call: 'logout' },
      setDocUploadWizardIndex: { $set: 'docUploadWizardIndex' },
      uploadInitialize: { $call: 'uploadInitialize' },
      showErrorModal: true,
      errorTitle: true,
      setBlurModalError: { $set: 'showErrorModal' },
      initializeSuccess: true,
      loading: true,
      setInitializeSuccess: { $set: 'initializeSuccess' },
      winUserId:true,
    },
    auth: {
      onLogout: { $call: 'logout' },
      setUserId: { $set: 'userId'}
    },
  }
})(LandingPage);
